// extracted by mini-css-extract-plugin
export default {"container":"input-mood_container__jKVf5","gradient":"input-mood_gradient__I38ct"};